
<template>
  <div id="startpage">
    <LanguageSelect v-on:language-changed="onLangChanged"></LanguageSelect>
    <ConsentManager ref="cm"></ConsentManager>
    <div id="startpage__logo"><img src="../assets/static/logo_intro.png" /></div>

    <div id="startpage__content">
      <div id="startpage__content__left"  class="startpage__content-left">      <div id="startpage__figures_left" class="startpage__figures">
        <img v-if="$i18n.locale=='de'" src="../assets/static/fig_rosalee_de.png">
        <img v-if="$i18n.locale=='el'" src="../assets/static/fig_rosalee_el.png">
        <img v-if="$i18n.locale=='en'" src="../assets/static/fig_rosalee_en.png">
        <img v-if="$i18n.locale=='es'" src="../assets/static/fig_rosalee_es.png">
        <img v-if="$i18n.locale=='fr'" src="../assets/static/fig_rosalee_fr.png">
        <img v-if="$i18n.locale=='it'" src="../assets/static/fig_rosalee_it.png">
        <img v-if="$i18n.locale=='nl'" src="../assets/static/fig_rosalee_nl.png">
        <img v-if="$i18n.locale=='pl'" src="../assets/static/fig_rosalee_pl.png">
        <img v-if="$i18n.locale=='pt'" src="../assets/static/fig_rosalee_pt.png">
      </div></div>

      <div id="startpage__content__center" class="startpage__content-center">

        <div id="startpage__content__center_wrapper">
          <h1 class="lightblue" >{{ $t('start_headline') }} </h1>
          <div class="startpage__description"><span v-html="$t('start_description') "></span></div>

          <div id="sartpage__description-slider">
            <VueSlickCarousel v-bind="settings" class="startpage-slider" @swipe="swipeAction" @beforeChange="beforeChangeAction" @afterChange="aftereChangeAction">
              <div  draggable="false" class="slide" v-for="index in 6" :key="index"  @click="openHelp(index)">
                <img draggable="false" :src="('../images/help_' + index +'.jpg')" class="help__image" >
              </div>
            </VueSlickCarousel>
<!--
            <flickity ref="flickity" :options="flickityOptions">
              <img  v-for="index in 6" :key="index"  :data-flickity-lazyload="('../images/anleitung' + index +'.png')" class="help__image">
            </flickity>
-->

            <!--
            <agile :options="settings">
              <div  class="slide" v-for="index in 6" :key="index" >
                <img :src="('../images/anleitung' + index +'.png')" class="help__image">
              </div>
              <template slot="prevButton">ertert </template>
              <template slot="nextButton">next</template>
            </agile>
-->
          </div>
        </div>

          <!--
          <agile :options="settings">
            <div  class="slide" v-for="index in 6" :key="index" >
              <img :src="('../images/anleitung' + index +'.png')" class="help__image">
            </div>
            <template slot="prevButton">ertert </template>
            <template slot="nextButton">next</template>
          </agile>
--><!--

          <VueSlickCarousel :arrows="true" :dots="true">
            <div  class="slide" v-for="index in 6" :key="index" >
              <img :src="('../images/anleitung' + index +'.png')" class="help__image">
            </div>
          </VueSlickCarousel>-->

      </div>
      <div id="startpage__content__right"  class="startpage__content-right">
        <div id="startpage__figures-right-back"  class="startpage__figures">
          <img src="../assets/static/fIg_arzt.png">
        </div>
        <div id="startpage__figures-right-front"  class="startpage__figures">
          <img src="../assets/static/fig_ritter.png">
        </div>
      </div>

    </div>

        <!--
        <VueSlickCarousel v-bind="settings" ref="carousel" v-show="showDelayed">
          <div v-for="index in 6" :key="index" class="slideElement">
            <img :src="('../images/anleitung' + index +'.png')" class="help__image">
          </div>
        </VueSlickCarousel>
        -->

<div id="startpage__footer">
  <div id="policy-box">
   <div class="policy-box__checkbox" >
     <img v-if="policyaccepted" src="../assets/checkbox_checked.png" @click="togglePolicy">
     <img v-if="!policyaccepted" src="../assets/checkbox_unchecked.png" @click="togglePolicy">
   </div>
    <!--<label class="checkbox-label" for="privacy-checkbox">{{ $t('start_policy') }}</label>-->
    <div  v-if="$i18n.locale=='de'" id="policy-box__text">Sie müssen diesen <a target="_blank" href="privacy/datenschutz_de.html">Nutzungsbedingungen</a> für Apps zustimmen, um die auf dieser Website eingestellten Apps nutzen zu können. Mit dieser Zustimmung erklären Sie Ihr Einverständnis mit den nachstehenden Nutzungsbedingungen und sorgen auch dafür, dass im Falle einer Nutzung durch Ihr Kind / Ihre Kinder diese Nutzungsbedingungen eingehalten werden. Wir behalten uns vor, diese Nutzungsbedingungen zu ändern und werden dann die entsprechend aktualisierte Fassung auf unserer Website einstellen.</div>
    <div  v-if="$i18n.locale=='el'" id="policy-box__text_el">Πρέπει να αποδεχτείτε αυτούς τους <a target="_blank" href="privacy/datenschutz_el.html">όρους χρήσης</a> για να χρησιμοποιήσετε τις εφαρμογές που δημοσιεύονται σε αυτόν τον ιστότοπο. Συμφωνώντας με αυτούς τους όρους χρήσης, δηλώνετε ότι συμφωνείτε με τους ακόλουθους όρους χρήσης και θα διασφαλίσετε επίσης ότι εάν το παιδί / τα παιδιά σας χρησιμοποιήσουν τις εφαρμογές, θα συμμορφωθούν με αυτούς τους όρους χρήσης. Διατηρούμε το δικαίωμα να αλλάξουμε αυτούς τους όρους χρήσης και μετά θα δημοσιεύσουμε την ενημερωμένη έκδοση στον ιστότοπό μας.</div>
    <div  v-if="$i18n.locale=='en'" id="policy-box__text_en">You must agree to these <a target="_blank" href="privacy/datenschutz_en.html">terms of use</a> in order to use the apps posted on this site. By agreeing to these terms of use, you declare your agreement with the following terms of use and will also ensure that if your child/children use the apps, they will comply with these terms of use. We reserve the right to change these terms of use and will then post the updated version on our website.</div>
    <div  v-if="$i18n.locale=='es'" id="policy-box__text_es">Debes aceptar estos <a target="_blank" href="privacy/datenschutz_es.html">términos de uso</a> para poder utilizar las aplicaciones publicadas en este sitio. Al aceptar estos términos de uso, declaras tu conformidad con los siguientes términos de uso y también te asegurarás que si tu hijo/hijos utilizan las aplicaciones, cumplirán con estos términos de uso. Nos reservamos el derecho de modificar estas condiciones de uso y publicaremos la versión actualizada en nuestro sitio web.</div>
    <div  v-if="$i18n.locale=='fr'" id="policy-box__text_fr">Vous devez d'abord accepter les <a target="_blank" href="privacy/datenschutz_fr.html">conditions d'utilisation</a> pour utiliser les applications de ce site. En acceptant ces conditions d'utilisation, vous donnez votre consentement sur ces conditions et vous assurez également que si votre/vos enfants utilisent ces applications, ils se conformeront à ces conditions d'utilisation. Nous nous réservons le droit de modifier ces conditions d'utilisation et publierons alors la version mise à jour sur notre site Internet.</div>
    <div  v-if="$i18n.locale=='it'" id="policy-box__text_it">Lei deve accettare queste <a target="_blank" href="privacy/datenschutz_it.html">condizioni d'uso</a> per poter usufruire delle applicazioni utilizzate su questo sito. Accettando queste condizioni d'uso, manifestate il vostro consenso alle seguenti condizioni d'uso e vi assicurerete anche che qualora vostro figlio /i vostri figli utilizzino le app, essi si atterranno a queste condizioni d'uso. Ci riserviamo il diritto di modificare queste condizioni d'uso e pubblicheremo in seguito la versione aggiornata sul nostro sito web.</div>
    <div  v-if="$i18n.locale=='nl'" id="policy-box__text_nl">U moet akkoord gaan met deze <a target="_blank" href="privacy/datenschutz_nl.html">gebruiksvoorwaarden</a> voor apps om de apps op deze website te kunnen gebruiken. Met deze toestemming verklaart u akkoord te gaan met de volgende gebruiksvoorwaarden en zorgt u er tevens voor dat deze gebruiksvoorwaarden worden nageleefd bij gebruik door uw kind/kinderen. We behouden ons het recht om deze gebruiksvoorwaarden te wijzigen en zullen de bijgewerkte versie op onze website plaatsen.</div>
    <div  v-if="$i18n.locale=='pl'" id="policy-box__text_pl">Aby móc korzystać z różnych aplikacji na tej stronie internetowej, należy wyrazić zgodę na ich korzystanie. Udzielając zezwolenia są Państwo zgodni z naszym poniższym <a target="_blank" href="privacy/datenschutz_pl.html">Regulaminem korzystania z aplikacji</a> i zapewniają Państwo, że podczas używania aplikacji przez Państwa dziecko/dzieci warunki te zostaną dotrzymane. Zastrzegamy sobie prawo do zmiany niniejszego Regulaminu, którego aktualizacje będą wstawiane na naszą stronę internetową.</div>
    <div  v-if="$i18n.locale=='pt'" id="policy-box__text_pt">Deve concordar com estes <a target="_blank" href="privacy/datenschutz_pt.html">termos de utilização</a> para poder utilizar as aplicações publicadas neste site. Ao concordar com estes termos de utilização, declara que concorda com os seguintes termos e também irá garantir que, caso os seus filhos utilizem as aplicações, eles cumprem com estes termos de utilização. Reservamos o direito de alterar estes termos de utilização e, posteriormente, publicaremos a versão atualizada no nosso site.</div>
  </div>
  <router-link to="titlepage" v-bind:class="{ disabled: !policyaccepted }" class="button-big">{{ $t('start_go') }}</router-link>
<br>
</div>

  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import LanguageSelect from '../components/LanguageSelect'
import ConsentManager from '../components/Consent'

export default {
  name: 'Startpage',
  components: { VueSlickCarousel, LanguageSelect, ConsentManager },
  data: () => {
    return {
      showDelayed: false,
      sliderClickable: true,

      settings: {
        slidesToShow: 3,
        infinite: false,
        swipe: true,
        dots: true,

        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]

      },
      langs: ['de', 'el', 'en', 'es', 'fr', 'it', 'nl', 'pl', 'pt'],
      policyaccepted: false
    }
  },
  created () {
    // this.doTrack('startpage');
    window.track('Startseite')
    setTimeout(() => {
      this.showDelayed = true
      this.$nextTick(() => {
      })
    }, 1000)
  },
  methods: {
    onLangChanged(lang) {
      this.$refs.cm.init(lang);
    },
    openHelp (id) {
      if (this.sliderClickable === true) {
        // console.log('openHelp 1', id)
      }
    },
    openHelp2 (id) {
      if (this.sliderClickable === true) {
        // console.log('openHelp 2', id)
      }
    },
    beforeChangeAction () {

    },
    aftereChangeAction () {
      this.sliderClickable = true
    },
    swipeAction () {
      this.sliderClickable = false
    },
    togglePolicy () {
      this.policyaccepted = !this.policyaccepted
    }
  }

}
</script>
<style lang="scss" scoped>
  $lightBlue : #0095d4;
  $footerHeight:150px;

  #policy-box{
    a, a:active, a:hover, a:visited{
      text-decoration: underline;
      color: white;
      font-weight: bold;
    }
  }
h1{
  padding-left: 1em;
  padding-right: 1em;
}
  #startpage{

    height: 100vh;
    width:100vw;
    position: absolute;
    top:0;
    left:0;
    overflow-x: hidden;
    overflow-y: visible;
    #startpage__logo{
      max-width: 500px;
      width:90%;
      height: auto;
      padding-top: 4rem;
      padding-bottom: 0;
      box-sizing: border-box;
      margin: 0 auto;
      img{
        width: 100%;
        height: auto;
      }
    }
  }

  .startpage__description{
    color: $lightBlue;
    max-width: 550px;
    font-size: 15px;
    margin: 0 auto;
    font-family: 'Open Sans', sans-serif;

  }
  .startpage-slider{
    width: 85%;
    margin:0 auto;

  }
  #startpage__content {
    background: url('~@/assets/static/start_white.png');
    background-size: 100% 100%;
    background-position: 50% 0%;
    background-repeat: no-repeat;
    position: relative;
    width: 100vw;
    display: flex;
    width: 100%;

    margin: 0 auto;
    //height: calc(100vh - #{$headerHeight} - #{$footerHeight});
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;

    .startpage__content-left {
      position: relative;
      flex: 20% 0 0;
      pointer-events: none;
    }

    .startpage__content-center {
      position: relative;
      flex: 90% 0 0;
      height:100%;
      width:100%;
      max-width:700px;
      z-index:2;

    }
    #startpage__content__center_wrapper {
      padding-top:4em;

    }
    .startpage-slider{
      margin-top: 0em;
      margin-bottom: 3em;
      padding: 1em;

      img{
        pointer-events: none;
        @media (hover: hover) {
          pointer-events: auto;
        }
      }
    }

  }

    .startpage__content-right{
      position: relative;
      flex: 20% 0 0;
      background-color: yellow;
      pointer-events: none;
    }

  .startpage__figures{
    position: absolute;
    img{
      width:120%;
      height:auto;
    }
  }
  #startpage__figures_left{
    width:100%;
    margin-top:8em;
    z-index: 20;
    right:-45px;
    max-width: 220px;
    @media (max-width: 850px) {
      display: none;
    }
  }
  #startpage__figures-right-back{
    left:-120px;
    z-index: 0;
    max-width: 200px;
    margin-top:6em;
    @media (max-width: 650px) {
      display: none;
    }
  }
  #startpage__figures-right-front{
    left:-70px;
    margin-top:15em;
    z-index: 30;
    max-width: 250px;
    @media (max-width: 890px) {
      display: none;
    }
  }

  .help__image{
    width:90%;
    height: auto;
    margin: 0 auto;
  }
  #startpage__footer{
    margin-bottom: 3em;
  }
  #policy-box{
    margin: 0 auto;
    display: flex;
    color: white;
    text-align: left;
    max-width:700px;
    margin-top: 0;
    margin-bottom: 1em;
    font-family: "Open Sans";
    font-size: 0.9em;
    padding: 1em;
    .policy-box__checkbox{
      padding-right: 1em;
      padding-top: 5px;
      cursor: pointer;
    }
  }

</style>
<style  lang="scss">
  h2{
    margin: 0;
    padding: 0;
  }
  .disabled {
      pointer-events:none;
      opacity:0.4;
    }
  .startpage__description{
    a, a:active, a:hover, a:visited{
      text-decoration: underline;
      color: #0095d4;
      font-weight: bold;
    }
  }
</style>
